import { testimonials } from '@/mocks/articles';

export default function TestimonialsSection() {
  return (
    <section className="w-full bg-background-200 py-16 md:py-20">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-primary-500"></div>
            <span className="text-xs text-foreground-500 tracking-wider">瓜友原声</span>
          </div>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-50 leading-tight">
            吃瓜群众
            <br />
            怎么说
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            真实评论，不信来看
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.id}
              className={`rounded-xl p-6 border border-secondary-800/30 transition-all duration-300 hover:border-secondary-600/50 ${
                index >= 3 ? 'bg-background-300/50' : 'bg-background-300'
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < t.rating
                        ? 'ri-star-fill text-primary-400'
                        : 'ri-star-line text-foreground-600'
                    }`}
                  ></i>
                ))}
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-50 mb-2">
                {t.headline}
              </h3>
              <p className={`text-sm leading-relaxed ${
                index >= 3 ? 'text-foreground-600' : 'text-foreground-400'
              }`}>
                {t.comment}
              </p>
              <div className="mt-5 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-200">{t.name}</p>
                  <p className="text-xs text-foreground-600">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}